import './CSS/App.css';
import Navbar from './Components/NavBar'; 
import Home from './Components/Home';
import Careers from './Components/Careers';
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import AboutUs from './Components/AboutUs';
import Services from './Components/services';
import Consultancy from './Components/Services/Consultancy'
import WeDev from './Components/Services/WebDev'
import ContactUs from './Components/ContactUs'
import ServiceNow from './Components/Services/ServiceNow'
import Staffing from './Components/Services/Staffing'
import { ThemeProvider } from './Context/ThemeProvider';
import ScrollToTop from "./Components/ScrollToTop";

function App() {
  return (
    <ThemeProvider>
    <Router>
      <ScrollToTop />
      <div className="App">
        <Navbar /> 
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/career" element={<Careers />} />
          <Route path="/about" element={<AboutUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/services/consultancy" element={<Consultancy />} />
          <Route path="/services/web-dev" element={<WeDev />} />
          <Route path="/services/servicenow" element={<ServiceNow />} />
          <Route path="/services/staffing" element={<Staffing />} />
          <Route path="/contact" element={<ContactUs />} />

        </Routes>
      </div>
    </Router>
    </ThemeProvider>
  );
}

export default App;
